import { Breadcrumb } from 'antd';
import styled from 'styled-components';
const BreadcrumbItemStyled = styled(Breadcrumb.Item)`
  font-size: 18px;
  font-weight: 500;
`;
export default BreadcrumbItemStyled;
